import { render, staticRenderFns } from "./DescriptionCard.vue?vue&type=template&id=7252caca&scoped=true&"
import script from "./DescriptionCard.vue?vue&type=script&lang=js&"
export * from "./DescriptionCard.vue?vue&type=script&lang=js&"
import style0 from "./DescriptionCard.vue?vue&type=style&index=0&id=7252caca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7252caca",
  null
  
)

export default component.exports